import App from "./App";
import { createRoot } from "react-dom/client";
import '../static/scss/index.scss';



const root = createRoot(document.getElementById("root"));
root.render(<App/>);